import script from "./UsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersView.vue?vue&type=script&setup=true&lang=ts"

import "./UsersView.vue?vue&type=style&index=0&id=967b9e88&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-967b9e88"]])

export default __exports__